import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const URL = getBaseUrl('/aiProviders/');

export async function getAiProviders() {
    return await appRequest.doGetRequest(URL);
}

export async function createAiProvider(data) {
    return await appRequest.doPostRequest(URL, data);
}

export async function updateAiProvider(id, data) {
    return await appRequest.doPatchRequest(`${URL}${id}`, data);
}

export async function deleteAiProvider(id) {
    return await appRequest.doDeleteRequest(`${URL}${id}`);
}

export async function setPrimaryAiProvider(id) {
    return await appRequest.doPostRequest(`${URL}${id}/setPrimary`, {});
}

export async function testAiProvider(id) {
    return await appRequest.doPostRequest(`${URL}${id}/test`, {});
}

export async function getProviderModels(id) {
    return await appRequest.doGetRequest(`${URL}${id}/models`);
}

export async function getProviderPlans() {
    return await appRequest.doGetRequest(`${URL}plans`);
}

// Orientação de IA: custo projetado por provedor, saúde 24h, alertas e papéis por finalidade.
export async function getAiGuidance() {
    return await appRequest.doGetRequest(`${URL}guidance`);
}

export async function setAiPurposeRouting(purpose, providerId) {
    return await appRequest.doPatchRequest(`${URL}purpose-routing`, { purpose, providerId });
}

// Fix de 1 clique do alerta "pago no sinal": tira do sinal e pina nas revisões.
export async function applyRecommendedRole(id) {
    return await appRequest.doPostRequest(`${URL}${id}/recommended-role`, {});
}

// Fila ordenada por grupo de trabalho (FACTORY/STRATEGY/RISK): quem é titular, quem é reserva
// e por quê (frase pronta em português, sem falar em token).
export async function getAiProviderGroups() {
    return await appRequest.doGetRequest(`${URL}groups`);
}
